<template>
  <div
    class="lang-switch d-inline-flex align-items-center"
    :class="{ 'lang-switch--light': light }"
    role="group"
    :aria-label="$t('common.langTh') + ' / ' + $t('common.langEn')"
  >
    <!-- EN ก่อน แล้ว TH — TH ชิดขวา (ขอบจอ) ลดโอกาสถูกชั้นอื่นทับจากด้านซ้ายของแถบ -->
    <button
      type="button"
      class="lang-btn"
      :class="{ active: currentLang === 'en' }"
      @click="onPickEn"
    >
      {{ $t('common.langEn') }}
    </button>
    <span class="lang-sep" aria-hidden="true">|</span>
    <button
      type="button"
      class="lang-btn lang-btn--th"
      :class="{ active: currentLang === 'th' }"
      @click="onPickTh"
    >
      {{ $t('common.langTh') }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LanguageSwitcher',
  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('locale', ['lang']),
    currentLang() {
      return this.lang
    },
  },
  methods: {
    onPickTh() {
      this.$store.commit('locale/SET_LANG', 'th')
    },
    onPickEn() {
      this.$store.commit('locale/SET_LANG', 'en')
    },
  },
}
</script>

<style scoped>
.lang-switch {
  font-size: 0.8125rem;
  margin-right: 0.5rem;
}
.lang-btn {
  border: none;
  background: transparent;
  padding: 0.35rem 0.5rem;
  min-width: 2.25rem;
  min-height: 2.25rem;
  color: rgba(0, 0, 0, 0.55);
  font-weight: 600;
  cursor: pointer;
  line-height: 1.2;
  border-radius: 4px;
  transition: color 0.15s ease, background 0.15s ease;
  pointer-events: auto;
}
.lang-btn:hover {
  color: #145654;
  background: rgba(20, 86, 84, 0.08);
}
.lang-btn.active {
  color: #145654;
}
.lang-switch--light .lang-btn {
  color: rgba(255, 255, 255, 0.75);
}
.lang-switch--light .lang-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}
.lang-switch--light .lang-btn.active {
  color: #ffd666;
}
.lang-switch--light .lang-sep {
  color: rgba(255, 255, 255, 0.35);
}
.lang-sep {
  color: rgba(0, 0, 0, 0.25);
  user-select: none;
  padding: 0 0.1rem;
  font-weight: 300;
}
</style>
